import React, { useState, useEffect, useRef } from 'react';
import Styles from './search.module.scss';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import 'react-simple-keyboard/build/css/index.css';
import CustomKeyboard from '@components/common/CustomKeyboard/index';

const Search = ({
  onChange,
  maxLength,
  autoKeyboard = false,
  getKeyboardStatus = false,
}) => {
  const [isSearch, setIsSearch] = useState(() => autoKeyboard);
  const ref = useRef(null);
  const keyboard = useRef(null);
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [searchString, setSearchString] = useState('');
  const [inputName, setInputName] = useState('search');
  const [inputs, setInputs] = useState({});
  const [typed, setTyped] = useState({});

  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const handleBlur = () => {
    const element = document.querySelector('#search');
    element.blur();
  };

  const closeKeyboard = () => {
    setIsSearch(false);
  };

  useEffect(() => {
    if (isSearch && searchString && keyboard.current) {
      keyboard.current.input.default = searchString;
    }
    if (isSearch && !searchString && keyboard.current) {
      keyboard.current.input.default = '';
    }
    if (getKeyboardStatus) {
      getKeyboardStatus(isSearch);
    }
  }, [isSearch, searchString]);


  const onClickBtn = (e) => {
    const value = e === '{bksp}' ? { ...inputs, [inputName]: inputs[inputName]?.slice(0, -1) } : { ...inputs, [inputName]: inputs[inputName] ? inputs[inputName].concat(e) : ''.concat(e) };
    setInputs({
      ...inputs,
      [inputName]: value[inputName]
    });
    onChange(value[inputName]);
    setSearchString(value[inputName]);
  };

  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: ''
    });
    setTyped({
      ...typed,
      [data]: ''
    });
  };

  return (
    <div
      ref={ref}
      className="h-100 position-relative p-1"
    >
      <input
        id="search"
        type="text"
        className={cn('h-100 od-text-primary text-primary px-2 border od-container-card-border border-color-primary rounded w-100 fs-14')}
        placeholder={LABEL().ITEM_SEARCH}
        onChange={(e) => { onChange(e.target.value); }}
        aria-label="Search"
        aria-labelledby="searchbtn"
        onClick={() => setIsSearch(true)}
        title="search"
        value={getInputValue('search')}
        onFocus={() => { setKeyboardType('default'); handleBlur(); setInputName('search'); }}
      />
      <div
        className="position-absolute fs-16 border-left od-container-card-border border-color-primary row mx-0 align-items-center justify-content-end"
        style={{
          right: '2%',
          top: '50%',
          width: '5%',
          transform: 'translateY(-50%)'
        }}
      >
        <i role="presentation" onClick={() => setIsSearch(true)} className="fa fa-search od-text-primary text-primary" aria-hidden="true" />
      </div>
      <div
        role="presentation"
        className={cn('position-absolute fs-16', { 'd-none': (searchString?.length === 0) })}
        style={{
          right: '9%',
          top: '50%',
          transform: 'translateY(-50%)'
        }}
        onClick={() => { setIsSearch(false); setEmpty('search'); setSearchString(''); onChange(''); }}
      >
        <i className="fa fa-times od-text-secondary text-secondary" aria-hidden="true" />
      </div>
      <div className={cn('d-flex flex-column od-border-secondary justify-content-end align-items-end', !isSearch ? 'd-none' : '', Styles.myTheme1)}>
        {isSearch && (
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={(e) => onClickBtn(e)}
              type={keyboardType}
              maxLength={maxLength}
              typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="btn"
              customClass="fs-30 background-primary od-app-background-color"
            />
        )}
      </div>
    </div>
  );
};

export default Search;
